module.exports = __webpack_public_path__ + "static/media/basket of oranges.6f50fcc7.jpeg";